const TimePeriodToggle = ({ value, onChange }) => (
  <div className="flex bg-gray-100 rounded-lg p-1">
    {['daily', 'weekly', 'monthly'].map(key => (
      <button
        key={key}
        onClick={() => onChange(key)}
        className={`px-3 py-1.5 text-xs font-medium rounded-md transition-all ${
          value === key
            ? 'bg-white text-gray-900 shadow-sm'
            : 'text-gray-500 hover:text-gray-700'
        }`}
      >
        {key.charAt(0).toUpperCase() + key.slice(1)}
      </button>
    ))}
  </div>
);

export default TimePeriodToggle;
